import { FC, useEffect, useRef, useState } from 'react';
import { TDropDownComponentProps } from './DropDownComponent.type';
import './DropDownComponent.scss';

const DropDownComponent: FC<TDropDownComponentProps> = ({
  items,
  userSelectedValue,
  defaultValue,
  handleChange,
  type,
  slug,
  validationError = false,
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const optionsRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (
      optionsRef.current &&
      !optionsRef.current.contains(event.target as Node) &&
      !target.classList.contains(`DropDownComponentValueIcon ${slug}`)
    ) {
      setShowOptions(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleOptionClick = (value: string) => {
    handleChange(type, slug, value);
    setShowOptions(false);
  };

  return (
    <div className="DropDownComponent">
      <div
        className={`DropDownComponentValue${validationError ? ' validationError' : ''}`}
        onClick={() => setShowOptions(!showOptions)}
      >
        <span>
          {items?.find((_item: any) => _item?.OPTION_VALUE === (userSelectedValue || defaultValue))
            ?.OPTION_TITLE || ''}
        </span>
        <img
          src={`/oo/assets/icon/down arrow.png`}
          alt="dropdown arrow"
          className={`DropDownComponentValueIcon ${slug}`}
        />
      </div>
      {showOptions && (
        <div className="DropDownComponentOptions" ref={optionsRef}>
          {items?.map((option: any) => (
            <p
              className={`DropDownComponentOptionsItem ${option?.OPTION_VALUE}`}
              key={option?.OPTION_VALUE}
              onClick={() => handleOptionClick(option?.OPTION_VALUE)}
            >
              <span>{option?.OPTION_TITLE}</span>
              {option?.OPTION_VALUE === (userSelectedValue || defaultValue) && (
                <img src="/oo/assets/icon/tick-icon.svg" alt="selected" />
              )}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropDownComponent;
